import PropTypes from 'prop-types';
import { useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import {  List, Typography, Accordion, AccordionSummary, AccordionDetails, Stack, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// project imports
import NavItem from '../NavItem';

// ==============================|| SIDEBAR MENU LIST GROUP WITH SINGLE SCROLLBAR ||============================== //

const NavGroup = (props) => {
  const theme = useTheme();
  const [expanded, setExpanded] = useState(null);

  const Icon=props.item?.icon

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null); // Ensure only one panel is expanded at a time
  };

  // Map through the menu items and render each as a NavItem or a nested dropdown
  const items = props.item.children?.map((menu) => {
    // console.log("menu",menu);

    switch (menu.type) {
      case 'item':
        return (
          <NavItem
            access={
              props.access.find((sub) => sub.menu_id === props.item.display_id)
            }
            key={menu.id}
            item={menu}
            level={1}
          />
        );
      default:
        return (
          <Typography key={menu.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return props.access.map((access) =>

    access.menu_id === props.item.display_id ? (
      <Accordion
        key={props.item.id}
        expanded={expanded === props.item.id} // Control which panel is open
        onChange={handleChange(props.item.id)}
        sx={{
          backgroundColor:"#592375",
          color:"#fff",
          boxShadow: 'none', // Removes default shadow
          border: 'none', // Ensures no border
          '&::before': { display: 'none' } // Removes default MUI pseudo-element border
        }}      >
        <AccordionSummary
          sx={{border:'none'}}
          aria-controls="panel1a-content"
          id="panel1-header"
          expandIcon={<ExpandMoreIcon sx={{color:"#fff"}}/>}
        >
          <Stack direction="row" alignItems="center">
            <Box sx={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Icon sx={{color:"#fff",fontSize:"20px"}}/>
            </Box>
            <Typography variant="caption"  sx={{ ...theme.typography.menuCaption,color:"#fff" }} color="#fff" display="block" gutterBottom>
              {props.item.title}
            </Typography>
          </Stack>

        </AccordionSummary>
        <AccordionDetails   sx={{border:'none',backgroundColor:"#7D459B",backdropFilter:"opacity(0.3)"}}>
          <List sx={{color:"#fff"}}>
            {items}
          </List>
          {/* <Divider sx={{ mt: 0.25, mb: 1.25 }} /> */}
        </AccordionDetails>
      </Accordion>
    ) : null
  );
};

NavGroup.propTypes = {
  item: PropTypes.object.isRequired,
  access: PropTypes.array.isRequired
};

export default NavGroup;
